<template>
  <div class="container-fluid">
    <div v-if="avatar._id" class="row flex-row">
      <div class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ avatar.avatarName }}</h3>
            <p class="text-center">{{ avatar.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div v-if="avatar.imageUrl" class="text-center mb-3">
              <img :src="avatar.imageUrl" alt="" style="max-width: 100%; max-height: 160px; object-fit: contain;" />
            </div>
            <div class="form-group px-3">
              <label class="form-control-label">تصویر نمایشی (ادمین)</label>
              <input type="file" class="form-control" accept="image/*" @change="imageSelected" />
              <button
                v-if="imageFile"
                type="button"
                class="btn btn-gradient-01 btn-sm mt-2 w-100"
                @click="uploadImage"
              >
                آپلود تصویر
              </button>
            </div>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات ترکیب</h4>
          </div>
          <div class="widget-body">
            <form id="avatarForm" class="form-horizontal">
              <!-- avatar english name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام آواتار</label>
                <div class="col-lg-6">
                  <input type="text" name="avatarName" class="form-control" :value="avatar.avatarName" />
                </div>
              </div>

              <!-- avatarIndex -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >ایندکس آواتار در اپلیکیشن (این مورد باید با اپلیکیشن سازگار باشد، تغیرش ندهید)</label
                >
                <div class="col-lg-6">
                  <input type="number" name="avatarIndex" class="form-control" :value="avatar.avatarIndex" />
                </div>
              </div>

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">جنسیت آواتار</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isGirl" id>
                    <option value="true" :selected="avatar.isGirl">دخترونه</option>
                    <option value="false" :selected="!avatar.isGirl">پسرونه</option>
                  </select>
                </div>
              </div>

              <!-- is available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت آواتار</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isAvailable" id>
                    <option value="true" :selected="avatar.isAvailable">فعال</option>
                    <option value="false" :selected="!avatar.isAvailable">غیر فعال</option>
                  </select>
                </div>
              </div>
              <!-- is default -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">ترکیب دیفالت</label>
                <div class="col-lg-6">
                  <input type="checkbox" name="isDefault" id :checked="avatar.isDefault" />
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/avatars">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import avatarService from '../../../../services/avatar';
export default {
  name: 'avatardetail',
  data() {
    return {
      avatar: {},
      imageFile: null,
    };
  },
  created() {
    this.getavatar();
  },
  methods: {
    async getavatar() {
      try {
        const avatar = await avatarService.findAvatarById(this.$route.query.id);
        console.log(avatar);
        this.avatar = avatar;
      } catch (err) {
        console.log(err);
      }
    },

    async save() {
      const form = document.getElementById('avatarForm');
      const body = {
        _id: this.avatar._id,
        avatarName: form.avatarName.value,
        avatarIndex: form.avatarIndex.value,
        isAvailable: form.isAvailable.value == 'true',
        isGirl: form.isGirl.value == 'true',
        isDefault: form.isDefault.checked,
      };
      console.log(body);
      try {
        await avatarService.updateAvatar(body);
        this.getavatar();
        window.notif({ isError: false, mssg: 'اپدیت شد' });
      } catch (err) {
        window.notif({ isError: true, mssg: 'مشکلی پیش آمده' });
        console.log(err);
      }

      console.log(body);
    },

    imageSelected(e) {
      this.imageFile = e.target.files[0] || null;
    },

    async uploadImage() {
      if (!this.imageFile) {
        return window.notif({ isError: true, mssg: 'تصویری انتخاب نشده است' });
      }
      const fileSizeMb = this.imageFile.size / 1024 / 1024;
      if (fileSizeMb > 2) {
        return window.notif({ isError: true, mssg: 'حجم فایل زیاد است (حداکثر ۲ مگابایت)' });
      }
      try {
        await avatarService.uploadAvatarImage(this.avatar._id, this.imageFile);
        this.imageFile = null;
        await this.getavatar();
        window.notif({ isError: false, mssg: 'تصویر آپلود شد' });
      } catch (err) {
        window.notif({ isError: true, mssg: 'مشکلی در آپلود تصویر پیش آمده' });
      }
    },
  },
};
</script>
